import React from 'react';
import Popup from './Popup.js';
import db from './db.js';
import Table from 'react-expandable-table';
import ErrorBoundary from './ErrorBoundary.js';
import TableScrollbar from 'react-table-scrollbar';
import Dropdown from 'react-dropdown'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
var TableColumnRender= require( "./TableColumnRender.js");
var functions = require("./functions.js");

// TextEditor component
export default class ShippoPopup extends React.Component {

    emptyShippingOptionsResults={"messages":[], resultMessage:{rates:[]}};
    emptyPurchasedResult={"resultData":{"label_url":"","tracking_number":""}};
    selectRateDescription="";
    
     // Constructor 
     constructor(props) {
        super(props);
        this.state= {
            shipperMessages:"",
            shippoRequest:{},
            shippoResult:{},
            shippingOptionsResults:this.emptyShippingOptionsResults,
            purchased:Object.assign({}, this.emptyPurchasedResult),
            warnings:""
        };
    };
    componentDidUpdate() {

    }    
    render(){
        try {
            let shipperMessages=this.state.shipperMessages;
            return(this.props.shippoAddress) ? (
                <div className="note-popup">
                    <Popup className="note-popup" trigger={ this.props.shippoAddress }  >
                        <div className="align-right">                           
                            <button className="close-btn" onClick={() => this.closePopup() }>x</button>
                        </div>
                        <h3>
                            Shipment via shippo (<a target="new" href="https://apps.goshippo.com/">shippo</a>)
                        </h3>
                        <div className="float-left">
                                <fieldset>
                                    <legend >
                                        Packaging (cookies)
                                        <Dropdown
                                            id="label_type" 
                                            onChange={this.updateFacilityTypeInputValue.bind(this)} 
                                            options={JSON.parse(this.props.securityObject.systemSettings.shipping_parcels )} 
                                            placeholder="Select Packaging Size or enter values below"
                                            className='med-dropdown' 
                                        />  
                                    </legend>
                                    <label className="short-label">length</label>
                                    <input id="c-length" className="shippo-input" name="shippo_length" onChange={functions.saveCookieValueFromEvent} defaultValue={functions.getCookieValue("shippo_length","10")}></input><br />
                                    <label className="short-label">width</label>
                                    <input id="c-width" className="shippo-input" name="shippo_width" onChange={functions.saveCookieValueFromEvent} defaultValue={functions.getCookieValue("shippo_width","11")}></input><br />
                                    <label className="short-label">height</label>
                                    <input id="c-height" className="shippo-input" name="shippo_height" onChange={functions.saveCookieValueFromEvent} defaultValue={functions.getCookieValue("shippo_height","12")}></input><br />
                                    <label className="short-label">size unit</label>
                                    <input id="c-distance_unit" className="shippo-input" name="shippo_distance_unit" onChange={functions.saveCookieValueFromEvent} defaultValue={functions.getCookieValue("shippo_distance_unit","in")}></input><br />
                                    <label className="short-label">weight</label>
                                    <input id="c-weight" className="shippo-input" name="shippo_weight" onChange={functions.saveCookieValueFromEvent} defaultValue={functions.getCookieValue("shippo_weight","20")}></input><br />
                                    <label className="short-label">weight unit</label>
                                    <input id="c-mass_unit" className="shippo-input" name="shippo_mass_unit" onChange={functions.saveCookieValueFromEvent} defaultValue={functions.getCookieValue("shippo_mass_unit","lb")}></input><br />
                                    <label className="short-label">Li Batteries</label>
                                    <input id="dangerousBatteries" type="checkbox" className="shippo-input" name="return_shipment" ></input><br />                                    
                                    <label className="short-label">charge on scan (return label)</label>
                                    <input id="returnShipment" type="checkbox" className="shippo-input" name="return_shipment" ></input><br />
                                    <select id="selectLabelSize">
                                        <option value="PDF_4x6">PDF_4x6</option>
                                        <option value="">default</option>
                                        <option value="PDF">PDF</option>
                                        <option value="PNG">PNG</option>
                                        <option value="PDF_2.3x7.5">PDF_2.3x7.5</option>
                                        <option value="PDF_4x8">PDF_4x8</option>
                                        <option value="PDF_A4">PDF_A4</option>
                                        <option value="PDF_A5">PDF_A5</option>
                                        <option value="PDF_A6">PDF_A6</option>
                                        <option value="ZPLII">ZPLII</option>
                                    </select>

                                </fieldset>
                               
                                &nbsp;&nbsp;
                                <error>{this.state.warnings}</error>
                                <br /><br />
                            </div>

                        <div id="frmShippo" name="frmShippo">
                            <div className="float-left">
                                <fieldset>
                                <legend >
                                        (Order)
                                        <br /> 
                                    </legend>                                    
                                    <label className="short-label">name</label>
                                    <input id="a-name" className="shippo-input" defaultValue={this.props.shippoAddress.display_contact_name}></input><br />
                                    <label className="short-label">street</label>
                                    <input id="a-street1" className="shippo-input" defaultValue={this.props.shippoAddress.display_address}></input><br />
                                    <label className="short-label">street2</label>
                                    <input id="a-street2" className="shippo-input" defaultValue={this.props.shippoAddress.display_address2}></input><br />
                                    <label className="short-label">city</label>
                                    <input id="a-city" className="shippo-input" defaultValue={this.props.shippoAddress.display_city}></input><br />
                                    <label className="short-label">state</label>
                                    <input id="a-state" className="shippo-input" defaultValue={this.props.shippoAddress.display_state}></input><br />
                                    <label className="short-label">zip</label>
                                    <input id="a-zip" className="shippo-input" defaultValue={this.props.shippoAddress.display_zip}></input><br />
                                    <label className="short-label">country</label>
                                    <input id="a-country" className="shippo-input" defaultValue={this.props.shippoAddress.display_country}></input><br />
                                    <label className="short-label">phone</label>
                                    <input id="a-phone" className="shippo-input" defaultValue={this.props.shippoAddress.display_phone}></input><br />
                                    <label className="short-label">email</label>
                                    <input id="a-email" className="shippo-input" defaultValue={this.props.shippoAddress.display_email}></input><br />
                                    <label className="short-label">company</label>
                                    <input id="a-company" className="shippo-input" defaultValue={this.props.shippoAddress.display_name}></input><br />
                                    <label className="short-label">reference</label>
                                    <input id="d-reference_1_out" className="shippo-input" defaultValue={this.props.shippoAddress.reference_1_out}></input><br />
                                    <label className="short-label"></label>
                                    <input id="d-reference_2_out" className="shippo-input" defaultValue={this.props.shippoAddress.reference_2_out}></input><br />
                                    <button  onClick={()=>this.getShippoRates("b","a")}>Get Rates for Shipment to this Location</button>
                                    <br></br><pre>{this.props.shippoAddress.shipping_notes}</pre>
                                    </fieldset>
                            </div>
                            <div className="float-left">
                                <fieldset>
                                    <legend >
                                        (cookies)
                                        <br /> 
                                    </legend>
                                    <label className="short-label">name</label>
                                    <input id="b-name" className="shippo-input" name="shippo_name" onChange={functions.saveCookieValueFromEvent} defaultValue={functions.getCookieValue("shippo_name","")} ></input><br />
                                    <label className="short-label">street</label>
                                    <input id="b-street1" className="shippo-input" name="shippo_street1" onChange={functions.saveCookieValueFromEvent}  defaultValue={functions.getCookieValue("shippo_street1","")}></input><br />
                                    <label className="short-label">street2</label>
                                    <input id="b-street2" className="shippo-input" name="shippo_street2" onChange={functions.saveCookieValueFromEvent}  defaultValue={functions.getCookieValue("shippo_street2","")}></input><br />                                    
                                    <label className="short-label">city</label>
                                    <input id="b-city" className="shippo-input" name="shippo_city" onChange={functions.saveCookieValueFromEvent} defaultValue={functions.getCookieValue("shippo_city","")}></input><br />
                                    <label className="short-label">state</label>
                                    <input id="b-state" className="shippo-input" name="shippo_state" onChange={functions.saveCookieValueFromEvent} defaultValue={functions.getCookieValue("shippo_state","")}></input><br />
                                    <label className="short-label">zip</label>
                                    <input id="b-zip" className="shippo-input" name="shippo_zip" onChange={functions.saveCookieValueFromEvent} defaultValue={functions.getCookieValue("shippo_zip","")}></input><br />
                                    <label className="short-label">country</label>
                                    <input id="b-country" className="shippo-input" name="shippo_country" onChange={functions.saveCookieValueFromEvent} defaultValue={functions.getCookieValue("shippo_country","")}></input><br />
                                    <label className="short-label">phone</label>
                                    <input id="b-phone" className="shippo-input" name="shippo_phone" onChange={functions.saveCookieValueFromEvent} defaultValue={functions.getCookieValue("shippo_phone","")}></input><br />
                                    <label className="short-label">email</label>
                                    <input id="b-email" className="shippo-input" name="shippo_email" onChange={functions.saveCookieValueFromEvent} defaultValue={functions.getCookieValue("shippo_email","")}></input><br />
                                    <label className="short-label">company</label>
                                    <input id="b-company" className="shippo-input" name="shippo_company" onChange={functions.saveCookieValueFromEvent} defaultValue={functions.getCookieValue("shippo_company","")}></input><br />
                                    <label className="short-label">reference</label>
                                    <input id="d-reference_1_in" className="shippo-input" defaultValue={this.props.shippoAddress.reference_1_in}></input><br />
                                    <label className="short-label"></label>
                                    <input id="d-reference_2_in" className="shippo-input" defaultValue={this.props.shippoAddress.reference_2_in}></input><br />
                                    <button  onClick={()=>this.getShippoRates("a","b")}>Get Rates for Shipment to this Location</button>
                                </fieldset>
                            </div>                        
                            <Popup trigger={this.state.shippingOptionsResults.resultMessage.rates.length>0}>
                                <div className="align-right">                           
                                    <button className="close-btn" onClick={() => 
                                        this.setState(
                                            {shippingOptionsResults:this.emptyShippingOptionsResults
                                            ,purchased:Object.assign({}, this.emptyPurchasedResult)
                                            }
                                        ) 
                                        }>x</button>
                                </div>
                                <h3>
                                    Shipment via shippo (<a target="new" href="https://apps.goshippo.com/">shippo</a>)
                                </h3>                                
                                <div className="float-left" >
                                    <Tabs defaultIndex="1">
                                        <TabList>
                                            <Tab >Rates Request</Tab>
                                            <Tab >Rates Request Messages</Tab>
                                            <Tab >Rates Request JSON</Tab>
                                            <Tab>Label Result</Tab>
                                        </TabList>
                                        <TabPanel>
    `                                        <pre className='shippo-request-display'>
                                                {JSON.stringify(this.state.shippoRequest,null,2)}
                                            </pre>
`                                        </TabPanel>
                                        <TabPanel>
                                            <pre className='shippo-request-display' 
                                                dangerouslySetInnerHTML={{ __html: shipperMessages }} 
                                            />
                                        </TabPanel>
                                        <TabPanel>
                                            <pre className='shippo-request-display'>
                                                {JSON.stringify(this.state.shippoResult,null,2)}
                                                </pre>
                                        </TabPanel>
                                        <TabPanel>
                                            <pre className='shippo-request-display'>
                                                {JSON.stringify(this.state.purchased,null,2)}
                                                </pre>
                                        </TabPanel>
                                    </Tabs>                                    
                                    note: if "charge on scan (return label)" is checked <br />then the to and from addresses above are reversed here
                                    <br />
                                    <error>{this.state.warnings}</error>
                                </div>
                                <div className="float-left" >
                                    <fieldset>
                                        <legend >
                                            Select Rate to Purchase Label
                                        </legend>
                                        <div  className="float-left, shippo-rateSelector">
                                            <TableScrollbar height="390px" >
                                                <ErrorBoundary>                                    
                                                    <Table key="rateTable" columns={[
                                                        { title:'provider', key: 'provider', width :15 }
                                                        ,{ title: 'cost', key: 'amount', width :15 }
                                                        ,{ title: 'service', key: 'servicelevel', width :15, render: TableColumnRender.renderShippoServiceLevel}
                                                        //,{ title:'currency', key: 'currency', width :15 }
                                                        ,{ title:'terms', key:'duration_terms',width:70, render: TableColumnRender.renderMultiLineText}
                                                        ,{ title:'estimated days', key:'estimated_days'}
                                                        ,{ title:'carrier account', key:'carrier_account'}
                                                        ]} 
                                                        dataSource={this.state.shippingOptionsResults.resultMessage.rates} 
                                                        onRowClick={this.purchaseShippoLabel.bind(this)}
                                                    />
                                                </ErrorBoundary>
                                            </TableScrollbar>
                                        </div>
                                        <br />
                                    </fieldset>
                                </div>
                                <div className="float-left" hidden={this.state.purchased.resultData.tracking_number==""}>
                                    <fieldset>
                                        <legend >
                                            Purchased
                                        </legend>                                    
                                        <div className="float-left">
                                            <a target="new" href={this.state.purchased.resultData.label_url}>Label</a><br />
                                            Tracking:{this.state.purchased.resultData.tracking_number}
                                            <br></br>
                                            <iframe title="Purchased Label" height="400px" width="400px" src={this.state.purchased.resultData.label_url}></iframe>
                                        </div>
                                    </fieldset>
                                </div>
                            </Popup>
                        </div>
                    </Popup>
                </div>
            ) :"";
        } catch (e){
            console.log(e);
            return "";
        }
    }
    closePopup(){
        this.setState( {
            shipperMessages:"",
            shippingOptionsResults:this.emptyShippingOptionsResults,
            purchased:Object.assign({}, this.emptyPurchasedResult),
            warnings:""
        });        
        this.props.onCloseShippoPopup();
    }

    getShippoRates( from, to){
        this.setState( {
            warnings:"Please Wait..."
        }); 
        let jsonLoad={"a":{},"b":{},"c":{}}
        //jsonLoad["a"].metadata=`{hubspot_customer:"${this.props.shippoAddress.hubspot_object_id}","device_app_user_email","${this.props.securityObject.userEmail}","facility_id":${this.props.facilityId}}`
        //jsonLoad["b"].metadata=jsonLoad["a"].metadata;
        //jsonLoad["c"].metadata=jsonLoad["a"].metadata;
        
        //var str = '';
        //var elem = document.getElementById('frmShippo').elements;
        var elem = document.getElementsByClassName("shippo-input");
        let isEmptyField=false;
        for(var i = 0; i < elem.length; i++)
        {
            ["a","b","c"].forEach((prefix)=>{
                if(elem[i].id.indexOf(prefix+"-")===0){
                    jsonLoad[prefix][elem[i].id.substr(2)]=elem[i].value
                    if(elem[i].id.indexOf("street2")<0){
                        if(elem[i].value===""){
                            isEmptyField=true;
                        }
                    }
                }

            })
        }     
        if(isEmptyField){

            this.setState({
                warnings:"All Fields Are Required"
        });
        } else {
            
            // if doing a return shippment flip to and from
            let ref1=document.getElementById("d-reference_1_out").value;
            let ref2=document.getElementById("d-reference_2_out").value;
            if(from==="a"){
                ref1=document.getElementById("d-reference_1_in").value;
                ref2=document.getElementById("d-reference_2_in").value;
            }            
            if(document.getElementById("returnShipment").checked){
                if(from==="a"){
                    from="b";
                    to="a";
                    ref1=document.getElementById("d-reference_1_in").value;
                    ref2=document.getElementById("d-reference_2_in").value;
                } else {
                    from="a";
                    to="b";
                    ref1=document.getElementById("d-reference_1_out").value;
                    ref2=document.getElementById("d-reference_2_out").value;                    
                }
            }
            let data={};
            //let isOrder=false;
            //let data={ 'isOrder':isOrder};
            //this.selectRateDescription="";
            //if( isOrder){
            //    data.from_address=jsonLoad[from];
            //    data.to_address=jsonLoad[to];            
            //    data.order_status="PAID";
            //    let items=[];
            //    this.props.lineItems.forEach( (item)=>{
            //        //items.push()
            //    })
            //    data.items=items;
            //    data.shipping_cost= "12.83",
            //    data.shipping_cost_currency= "USD",
                //data.shipping_method": "USPS First Class Package International Service",
            //    data.subtotal_price= "12.10",
            //    data.total_price= "24.93",
            //    data.total_tax= "0.00",
            //    data.currency= "USD",
            //    data.weight= "0.40",
            //    data.weight_unit="lb"                  
            //} else {
                data.address_from=jsonLoad[from];
                data.address_to=jsonLoad[to];            
                data.order_status=["UNKNOWN"];
                data.line_items=this.props.lineItems;
                data.parcels=jsonLoad["c"];
                data.metadata=`orderId:${this.props.orderId}`;
              
            //}
            if(document.getElementById("selectLabelSize").value!==""){
                data.label_file_type=document.getElementById("selectLabelSize").value;
            }
            this.selectRateDescription+="from:\n" + this.getAddressString(data.address_from)+"\n";
            this.selectRateDescription+="to:\n" + this.getAddressString(data.address_to)+"\n";
            data.extra= {
                "reference_1": ref1,
                "reference_2": ref2
            }
            if(document.getElementById("returnShipment").checked){
                data.extra.is_return=true;
                this.selectRateDescription+="Charge on Scan\n";
            }
            if(document.getElementById("dangerousBatteries").checked){
                data.extra.dangerous_goods= 
                {
                    "contains": true,
                    "lithium_batteries": {
                        "contains": true
                    }
                };
                this.selectRateDescription+="LI Batteries\n";
            }

            data.order_number=`${this.props.sourceOrderId} (${this.props.orderId})`
            
            data.async=false;
            //data.metadata=`orderId:${this.props.orderId},hubspot_customer:${this.props.shippoAddress.hubspot_object_id},device_app_user_email,${this.props.securityObject.userEmail},facility_id:${this.props.facilityId}`

            data.placed_at=new Date();
            this.setState({
                shippoRequest:data
            })
            db.saveData( this.props.securityObject, data, "api/sendOrderToShippo", 
                (res)=>{

                    this.setMessages(res);
                    //alert(JSON.stringify(res));
                    //this.props.onCloseShippoPopup();
                }, 
                (err)=>{
                    this.setMessages(err);

                    //alert(JSON.stringify(err));
                })  
        }
    }

    getAddressString(address){
        return JSON.stringify(address,null,2);
    }
    setMessages(res){

        let messages="";

        // if error
        if(res.resultCode===0){
            res.resultData.config.headers.Authorization="???";
            messages=JSON.stringify(res.resultData,null,2);
        // if no error
        } else {
            if(!res.resultData){
                res.resultData={}
            }
            if(!res.resultData.messages){
                res.resultData.messages=[];
            }                
            if(!res.resultData.rates){
                res.resultData.rates=[];
            }        
            this.setState({
                shippingOptionsResults:{resultMessage:res.resultData}
            });        
            res.resultData.messages.forEach( (msg) =>{
                if(msg.text.includes("Hard:")
                    || msg.text.includes("ERROR")){
                    messages+=`<error>${msg.source} ${msg.text}</error>\n`;
                } else {
                    messages+=`${msg.source} ${msg.text}\n`;
                }
            })
        }

        // sort rates
            res.resultData.rates.forEach( (rate) =>{
                rate.sort_order=5;
                if(rate.provider=="USPS" ){
                    rate.sort_order=1;
                } else if(rate.provider=="UPS" ){
                    rate.sort_order=2;
                    if(rate.servicelevel.token.includes("ups_ground_saver")){
                        rate.sort_order=6;
                    } else if(rate.servicelevel.token.includes("ups_ground")){
                        rate.sort_order=0;
                    }
                }
            })
        res.resultData.rates.sort( (a,b)=>{
            if(a.sort_order<b.sort_order){
                return -1;
            } else if(a.sort_order>b.sort_order){
                return 1;
            } else {
                return 0;
            }
        })
        //alert(messages);
        this.setState({
            shipperMessages:messages,
            shippoResult:res,
            warnings:""
        });        
    }
    purchaseShippoLabel(rowData, rowIndex){
        //rowData.servicelevel.name+"\n"
        //+rowData.duration_terms+"\n"
        //+rowData.amount+" "+rowData.currency+"\n"

        let confResult=window.confirm(`Are you sure you want to purchase this label\n ${rowData.provider} ${rowData.amount} ${rowData.currency}\n${rowData.servicelevel.name}\n${rowData.duration_terms}?`);
        console.log(`confResult:${confResult}`);
        if(confResult){
            this.setState( {
                warnings:"Please Wait..."
            });   
            let orderIdQuery="";
            
            db.saveData( this.props.securityObject
                , { 
                    purchased:rowData
                    ,shippoRequest:this.state.shippoRequest
                    //,shippingOptionsResults:this.state.shippingOptionsResults
                }
                , `api/shippoCreateOrderPurchaseShipment`
                +`?orderId=${this.props.orderId}`
                +`&sourceOrderId=${this.props.sourceOrderId}`
                +`&orderType=${this.props.orderType}`
                +`&shipmentCode=${this.props.shipmentCode}`
                +`&token=${rowData.servicelevel.token}`
                +orderIdQuery
                , 
                (res)=>{
                    this.setState({
                        //shipperMessages:"",
                        //shippingOptionsResults:{resultMessage:this.emptyShippingOptionsResults},
                        purchased:res,
                        warnings:"Request Complete"
                    });   
                    //this.setMessages(res);
                    alert(JSON.stringify(res));
                    //this.props.onCloseShippoPopup();
                }, 
                (err)=>{
                    //this.setMessages(err);
                    this.setState({
                        //shipperMessages:"",
                        //shippingOptionsResults:{resultMessage:this.emptyShippingOptionsResults},
                        purchased:err,
                        warnings:"Request Failed"
                    });   
                    //this.setMessages(res);                   
                    alert(JSON.stringify(err));
                })  

        } else {
                    this.setState({
                        warnings:"Request canceled by user"
                    });             
        }
    }
    updateFacilityTypeInputValue(option){
        document.getElementById("c-length").value=option.value.length;
        document.getElementById("c-width").value=option.value.width; 
        document.getElementById("c-height").value=option.value.height;
        document.getElementById("c-distance_unit").value=option.value.distance_unit;
        document.getElementById("c-weight").value=option.value.weight;
        document.getElementById("c-mass_unit").value=option.value.mass_unit;
    }

}
